import { RidangoReduxAction } from '@ridango/core';

import { RouteTripItem } from '../../schedule.model';
import { RouteTripActions } from './route-trip.actions';

export const ROUTE_TRIP_STATE_KEY = 'routeTrip';

export interface RouteTripState {
    stops: RouteTripItem[];
    loading: boolean;
}

export const ROUTE_TRIP_INITIAL_STATE: RouteTripState = {
    loading: false,
    stops: [],
};

export function routeTripReducer(
    state: RouteTripState = ROUTE_TRIP_INITIAL_STATE,
    action: RidangoReduxAction
): RouteTripState {
    switch (action.type) {
        case RouteTripActions.FETCH_ROUTE_TRIP:
            return {
                ...state,
                loading: true,
            };
        case RouteTripActions.FETCH_ROUTE_TRIP_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
    }

    return state;
}
